import { GET_CARD_DETAIL_SUCCESS, SET_CARD_DETAIL } from 'stash/actions/api';

// Converts the spacejam camelCase response to snake_case to ensure
// compatability across the app.
const camelToSnakeCase = (card) => {
	const customKeyMaps = {
		icon65x65_1x: 'icon_65x65_1x',
		icon65x65_2x: 'icon_65x65_2x',
		icon65x65_3x: 'icon_65x65_3x',
		icon90x90_1x: 'icon_90x90_1x',
		icon90x90_2x: 'icon_90x90_2x',
		icon90x90_3x: 'icon_90x90_3x',
		icon375x170_1x: 'icon_375x170_1x',
		icon375x170_2x: 'icon_375x170_2x',
		icon375x170_3x: 'icon_375x170_3x',
	};

	function convertKey(key) {
		return customKeyMaps[key] || key.replace(/([A-Z])/g, '_$1').toLowerCase();
	}

	return Object.keys(card).reduce((newCard, key) => {
		newCard[convertKey(key)] = card[key];
		return newCard;
	}, {});
};

const cards = (state = {}, action) => {
	switch (action.type) {
		case GET_CARD_DETAIL_SUCCESS: {
			const card = action.response.card;
			return {
				...state,
				selectedCard: {
					...state[card.id],
					...camelToSnakeCase(card),
				},
			};
		}
		case SET_CARD_DETAIL: {
			return {
				...state,
				selectedCard: action.card,
			};
		}

		default:
			return state;
	}
};

export default cards;
